export const initialState = {
  isSidebarOpened: false,
  isForceOpened: false,
};

export const TOGGLE_SIDEBAR = 'Layout/TOGGLE_SIDEBAR';
export const MOUSE_OVER_SIDEBAR = 'Layout/MOUSE_OVER_SIDEBAR';
export const MOUSE_OUT_SIDEBAR = 'Layout/MOUSE_OUT_SIDEBAR';
export const SELECT_MENUS = 'Layout/SELECT_MENUS';

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});
// sidebar menus seleted
export const seletedSidebarMenus = () => ({
  type: SELECT_MENUS,
});

export const mouseOverSidebar = () => ({
  type: MOUSE_OVER_SIDEBAR,
});

export const mouseOUTSidebar = () => ({
  type: MOUSE_OUT_SIDEBAR,
});

export default function LoginReducer(state = initialState, { type, payload }) {
  switch (type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarOpened: !state.isSidebarOpened,
        isForceOpened: !state.isForceOpened,
      };
      
    case SELECT_MENUS:
    case MOUSE_OVER_SIDEBAR:
    case MOUSE_OUT_SIDEBAR:
      if (state.isForceOpened) {
        return state; // No change if `isForceOpened` is true
      }
      
      switch (type) {
        case SELECT_MENUS:
          return {
            ...state,
            isSidebarOpened: false,
            isForceOpened: false,
          };
          
        case MOUSE_OVER_SIDEBAR:
          return {
            ...state,
            isSidebarOpened: true,
          };

        case MOUSE_OUT_SIDEBAR:
          return {
            ...state,
            isSidebarOpened: false,
          };
        
        default:
          return state;
      }
      
    default:
      return state;
  }
}

// export default function LoginReducer(state = initialState, { type, payload }) {
//   switch (type) {
//     case TOGGLE_SIDEBAR:
//       return {
//         ...state,
//         isSidebarOpened: !state.isSidebarOpened,
//         isForceOpened: !state.isForceOpened,
//       };
//     case SELECT_MENUS:
//       if (!state.isForceOpened) {
//         return {
//           ...state,
//           isSidebarOpened: false,
//           isForceOpened: false,
//         };
//       }
//     case MOUSE_OVER_SIDEBAR:
//       if (!state.isForceOpened) {
//         return {
//           ...state,
//           isSidebarOpened: true,
//         };
//       }
//     case MOUSE_OUT_SIDEBAR:
//       if (!state.isForceOpened) {
//         return {
//           ...state,
//           isSidebarOpened: false,
//         };
//       }
//     default:
//       return state;
//   }
// }
